import axios from 'axios'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})

export default {
  setAccessToken (accessToken) {
    httpClient.defaults.headers = { Authorization: `Bearer ${accessToken}` }
  },
  async getSubscription (id) {
    try {
      const { data } = await httpClient.get(`subscriptions/${id}`)
      return data
    } catch (e) {
      console.error(`Can't fetch subscription. Error: ${e.message}`)
      throw new Error('Cannot fetch subscription from API')
    }
  },
  async getMembers (clientId) {
    try {
      const { data } = await httpClient.get(`/${clientId}/users`)
      return data
    } catch (e) {
      console.error(`Can't fetch members. Error: ${e.message}`)
      throw new Error('Cannot fetch members from API')
    }
  },
  async addMember (clientId, email) {
    try {
      const { data } = await httpClient.post(`/${clientId}/users`, email)
      return data
    } catch (e) {
      console.error(`Can't invite new member. Error: ${e.message}`)
      throw new Error('Cannot  invite new member')
    }
  },
  async resendInvitation (clientId, memberId) {
    try {
      const { data } = await httpClient.post(`/${clientId}/users/${memberId}/resend`)
      return data
    } catch (e) {
      console.error(`Can't invite new member. Error: ${e.message}`)
      throw new Error('Cannot  invite new member')
    }
  },
  async removeMember (clientId, memberId) {
    try {
      await httpClient.post(`/${clientId}/users/${memberId}/delete`)
    } catch (e) {
      console.error(`Can't delete member. Error: ${e.message}`)
      throw new Error('Cannot delete member')
    }
  }
}
